import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatCheckbox } from '@angular/material/checkbox'
import { MatChip, MatChipListbox, MatChipOption, MatChipSet } from '@angular/material/chips'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MatTab, MatTabGroup } from '@angular/material/tabs'
import {
  ElderLocalizedInputComponent,
  ElderPaneContentComponent,
  ElderPaneSubtitleComponent,
  ElderSinglePaneWrapperComponent,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { Material } from '../material'

@Component({
  selector: 'app-material-detail',
  templateUrl: './material-detail.component.html',
  styleUrls: ['./material-detail.component.scss'],
  imports: [
    ElderPaneContentComponent,
    ElderSinglePaneWrapperComponent,
    ElderPaneSubtitleComponent,
    MatTabGroup,
    MatTab,
    MatFormField,
    MatLabel,
    MatInput,
    ElderLocalizedInputComponent,
    FormsModule,
    MatChipSet,
    MatChip,
    MatChipListbox,
    MatChipOption,
    MatCheckbox,
    ElderTranslatePipe,
  ],
})
export class MaterialDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  material = input.required<Material>()
}
